const debug = false
// const debug = "ServerSettings"

export enum ServerSettingsFieldType {
    VALUE   = 'value',
    OPTION  = 'option',
    CLASS   = 'class',
    BOOLEAN = 'boolean'
}

export default class ServerSettings {

    public _config  : any
    public _fields  : { [fieldId: string]: any }

    constructor(config : any, fields: any) {

        this._config            = config;
        this._fields            = fields

    }

    initValue(key:string) {
        debug && console.log(debug, "initValue() key=", key)

        const field = this._getField(key)

        switch (field.type) {

            case ServerSettingsFieldType.VALUE:
                return this._getValue(key)

            case ServerSettingsFieldType.OPTION:
                return this._getOptionValue(key)

            case ServerSettingsFieldType.BOOLEAN:
                return this._getBooleanValue(key)

            case ServerSettingsFieldType.CLASS:
                debug && console.log("    class=", field.class)
                return new field.class(this._getValue(key))

            default:
                console.error("ERROR #9982002831")
                console.error("field = ", field)
        }

    }

    valueToJson(resultObject:any, key:string) {
        const field = this._getField(key)

        debug && console.log(debug, 'valueToJson() key=', key)

        switch (field.type) {

            case ServerSettingsFieldType.CLASS:
                // @ts-ignore
                debug && console.log('    class=', this[key])
                // @ts-ignore
                resultObject[key] = this[key].toJson();
                break;

            case ServerSettingsFieldType.BOOLEAN:
            case ServerSettingsFieldType.VALUE:
            case ServerSettingsFieldType.OPTION:
                // @ts-ignore
                debug && console.log(debug, 'valueToJson', field.type, !_.isEqual(this[key], field.defaultValue), key, field, this[key], field.defaultValue)
                // @ts-ignore
                if (!_.isEqual(this[key], field.defaultValue)) {
                    // @ts-ignore
                    resultObject[key] = this[key]
                }
                break;

            default:
                console.log("ERROR #99854d831")
        }

    }

    _getField(fieldName:string) {
        // @ts-ignore
        if (!this._fields[fieldName]) {
            console.error("no field", fieldName, "found $jjdio")
        }

        // @ts-ignore
        return this._fields[fieldName]
    }


    _getValue(key:string) {
        debug && console.log(debug, 'getValue', key, 'defaultValue=', _.clone(this._fields[key].defaultValue))
        return _.get(
            this._config,
            key,
            _.clone(this._fields[key].defaultValue)
        )
    }

    _getOptionValue(key:string) {

        const field     = this._getField(key)
        let value       = this._getValue(key)

        // if no value -> default
        // if value not in options -> default

        if (_.indexOf(field.options, value) >-1) {
            return value
        } else {
            return field.defaultValue
        }
    }

    _getBooleanValue(key:string) {

        const field     = this._getField(key)
        let value       = this._getValue(key)

        const valueOptions  = [true, false]

        // if no value -> default
        // if value not in options -> default

        if (_.indexOf(valueOptions, value) >-1) {
            return value
        } else {
            return field.defaultValue
        }
    }



}



